import $ from 'jquery';

$('.button, .wp-block-button__link').each(function () {
    const $self = $(this);
    $self.attr('data-label', $self.text())
})
